/**
 * Theme Presets for Stellar
 * These are curated color schemes that companies can choose from
 */

export interface ThemePreset {
    id: string;
    name: string;
    description: string;
    preview: string; // emoji/icon for quick visual
    colors: {
        primaryColor: string;
        secondaryColor: string;
        backgroundColor: string;
        accentColor: string;
    };
}

export const themePresets: ThemePreset[] = [
    {
        id: 'daylight',
        name: 'Daylight',
        description: 'Clean and bright, perfect for productivity',
        preview: '☀️',
        colors: {
            primaryColor: '#3b82f6',
            secondaryColor: '#8b5cf6',
            backgroundColor: '#ffffff',
            accentColor: '#3b82f6',
        },
    },
    {
        id: 'night-sky',
        name: 'Night Sky',
        description: 'Easy on the eyes, elegant dark mode',
        preview: '🌙',
        colors: {
            primaryColor: '#818cf8',
            secondaryColor: '#a78bfa',
            backgroundColor: '#0f172a',
            accentColor: '#818cf8',
        },
    },
    {
        id: 'sunset',
        name: 'Sunset',
        description: 'Warm orange tones for a cozy feel',
        preview: '🌅',
        colors: {
            primaryColor: '#f97316',
            secondaryColor: '#fb923c',
            backgroundColor: '#1c1917',
            accentColor: '#f97316',
        },
    },
    {
        id: 'ocean',
        name: 'Ocean',
        description: 'Calm and refreshing blue-green palette',
        preview: '🌊',
        colors: {
            primaryColor: '#06b6d4',
            secondaryColor: '#22d3ee',
            backgroundColor: '#042f2e',
            accentColor: '#06b6d4',
        },
    },
    {
        id: 'forest',
        name: 'Forest',
        description: 'Natural green tones inspired by nature',
        preview: '🌲',
        colors: {
            primaryColor: '#22c55e',
            secondaryColor: '#4ade80',
            backgroundColor: '#14532d',
            accentColor: '#22c55e',
        },
    },
    {
        id: 'lavender',
        name: 'Lavender',
        description: 'Soft purple hues for a creative vibe',
        preview: '💜',
        colors: {
            primaryColor: '#a855f7',
            secondaryColor: '#c084fc',
            backgroundColor: '#faf5ff',
            accentColor: '#a855f7',
        },
    },
];

export function getPresetById(id: string): ThemePreset | undefined {
    return themePresets.find(p => p.id === id);
}
